// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"646":"5c434bd0","697":"573d5a98","779":"c845015b"}[chunkId] + ".chunk.css";
};